import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse, InvestInAgentPayload, InvestCreateResponse } from '@dopomogai/types';

const INVEST_PREFIX = '/invest';

export const investService = {
  /**
   * Triggers an investment in an agent using the user's credit balance.
   */
  makeInvestment: (payload: InvestInAgentPayload): ServiceResponse<InvestCreateResponse> => {
    return getApiClient().post<InvestCreateResponse>(`${INVEST_PREFIX}`, payload)
      .then(response => response.data)
      .catch(error => handleApiError(error, 'investing in agent'));
  },
};
